;(function() {
    var _$wrapper = null,

    init = function() {
        _$wrapper = $('.layout-assign-doctor');


        if (_$wrapper.length > 0) {
            setupAssignLinks();
        }
    },

    //
    // setup the assign links
    //
    setupAssignLinks = function() {
        _$wrapper.find('.lnk-assign').click(function() {
            var $a = $(this);
            var id = $a.attr('data-doctor-id');

            //call the server to get the popup content
            ailtire.ajax.get(
                '/assignDoctor/popup?id=' + id,
                function(html) {
                    ailtire.popup.open({
                        type: 'confirm',
                        title: 'Assign Tablet To Doctor',
                        content: html,
                        suppressCloseX: true,
                        afterOpen: function($popup) {
                            setTimeout(function() {
                                $popup.find('.modal-body').find('input').focus();
                            }, 300);
                        },
                        okCallback: function($popup) {
                            //create the form data
                            var formData = new FormData();

                            //get the form data
                            $popup.find('.modal-body').find('input').each(function() {
                                var $elem = $(this);
                                formData.append($elem.attr('name'), $elem.val());
                            });

                            //post it
                            ailtire.ajax.postFormData(
                                '/assignDoctor/popupSave',
                                formData,
                                function(result) {
                                    if (result.isValid) {
                                        //close the popup
                                        ailtire.popup.close($popup);

                                        //update page values
                                        var $td = $a.closest('tr').find('.td-tablets');
                                        var s = $td.html();

                                        console.log($td)

                                        if (s) {
                                            s += '<br/>' + result.tabletIdentifier;
                                        } else {
                                            s = result.tabletIdentifier;
                                        }
                                        console.log(s);

                                        $td.html(s);
                                    } else {
                                        //update popup content
                                        $popup.find('.modal-body').html(result.html);
                                    }
                                }
                            )

                            
                            //keep popup open
                            return false;
                        }
                    });
                }
            )
            return false;
        });

    },

    dummy = function(){};

    $(document).ready(init);

})();